import { createComponent } from "../utils";
import verb from "verb-nurbs-web";

export default createComponent({
  name: "Circle",
  description: "Create a circle",
  group: "Curve",
  icon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
      <circle
        cx="10.5"
        cy="10.5"
        fill="none"
        r="8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "radius",
      name: "Radius",
      type: "Number",
    },
    {
      id: "plane",
      name: "Plane",
      type: "Plane",
    },
  ],
  outputs: [
    {
      id: "circle",
      name: "Curve",
      type: "Curve",
      compute: ({ radius = 1, plane = [0, 0, 0] }) => {
        return new window.rhino.Circle(plane, radius || 1).toNurbsCurve();
      },
    },
  ],
});
